import '../scss/main.scss';

const navbar = document.querySelector('#navbar');
const navToggle = document.querySelector('#navToggle');
const modal = document.querySelector('#modal');
const overlay = document.querySelector('#overlay');
const modalButton = document.querySelectorAll('#modalFormButton');
const closeModalButton = document.querySelector('.closeButton');

navToggle.addEventListener('click', () => {
  const navbar_menu = document.querySelector('#navbar-collapse');
  if (navbar_menu.classList.contains('active')) {
    navbar_menu.classList.remove('active');
    navToggle.innerHTML = `<i class="fas fa-bars"></i>`;
  } else {
    navbar_menu.classList.add('active');
    navToggle.innerHTML = `<i class="fas fa-times"></i>`;
  }
});

// Navbar Scroll

window.onscroll = () => {
  if (window.scrollY > navbar.offsetTop * 10) {
    navbar.classList.add('active');
  } else {
    navbar.classList.remove('active');
  }
};

// Modal

modalButton.forEach((button) => {
  button.addEventListener('click', function () {
    modal.classList.add('active');
    overlay.classList.add('active');
  });
});

// Close Modal

closeModalButton.onclick = removeModal;

function removeModal() {
  modal.classList.remove('active');
  overlay.classList.remove('active');
}
